import { Box, CircularProgress } from '@mui/material'
import SearchSVG from 'components/svg/search'
import React, { PropsWithChildren } from 'react'
import { useHistory } from 'react-router-dom'
import { useStyles } from './styles'

interface ITableOverlay extends PropsWithChildren {
  isEmpty: boolean
  isSearch: boolean
  isLoading: boolean
  route: string
  searchMessage?: string
  searchRouteText?: string
  emptyMessage?: string
  emptyRouteText?: string
}

interface IEmptyComponent {
  route: string
  emptyMessage?: string
  emptyRouteText?: string
}

const LoadingComponent: React.FC = () => {
  const classes = useStyles()

  return (
    <Box className={classes.loadingContainer}>
      <CircularProgress size={156} />
    </Box>
  )
}

const EmptyComponent: React.FC<IEmptyComponent> = ({ route, emptyMessage, emptyRouteText }) => {
  const classes = useStyles()
  const history = useHistory()

  const handleNavigate = () => {
    history.push(route)
  }

  return (
    <Box className={classes.emptyContainer}>
      <SearchSVG className={classes.image} />
      <p>
        {emptyMessage}{' '}
        {emptyRouteText && (
          <>
            “<span onClick={handleNavigate}>{emptyRouteText}</span>”
          </>
        )}
        .
      </p>
    </Box>
  )
}

const TableOverlay: React.FC<ITableOverlay> = ({
  isEmpty,
  isLoading,
  isSearch,
  route,
  emptyMessage,
  emptyRouteText,
  searchMessage,
  searchRouteText,
  children,
}) => {
  if (isLoading && isEmpty && isSearch) {
    return <LoadingComponent />
  } else if (isLoading) {
    return <LoadingComponent />
  } else if (isEmpty && isSearch) {
    return (
      <EmptyComponent
        route={route}
        emptyMessage={searchMessage}
        emptyRouteText={searchRouteText}
      />
    )
  } else if (isEmpty) {
    return (
      <EmptyComponent
        route={route}
        emptyMessage={emptyMessage}
        emptyRouteText={emptyRouteText}
      />
    )
  }

  return <>{children}</>
}

export default TableOverlay
